'use strict';
angular.module('reporting.dashboards.controllers')
    .controller('ReportController', [
    '$scope',
    '$routeParams',
    '$window',
    '$q',
    '$timeout',
    '$log',
    '$location',
    '$injector',
    'rsContainers',
    'rsState',
    'rsEnvironment',
    'rsWidgets',
    'containerEvents',
    'enqueueExport',
    'reportService',
    'timezoneService',
    '$rootScope',
    '$http',
    'exportService',
    'metricsService',
    function ($scope, $routeParams, $window, $q, $timeout, $log, $location, $injector, containers, rsState, rsEnv, rsWidgets, containerEvents, enqueueExport, reportService, timezoneService, rootScope, $http, exportService, metricsService) {
        $scope.loaded = false;
        $scope.timezoneLabel = timezoneService.getFormattedLabel();
        $scope.$on('$routeChangeSuccess', function () {
            if (!$routeParams.pageId) {
                loadPage();
            }
            else {
                init();
            }
        });
        function loadPage() {
            var surveyId = rsEnv.get('surveyId');
            var containerId = rsEnv.get('containerId');
            reportService.getReport(surveyId, containerId)
                .then(gotoPage)
                .catch(function (err) {
                $scope.err = err;
            });
        }
        function gotoPage(report) {
            var pageId = 'Page_NoId', path = '';
            if (report.container.pages.length > 0) {
                pageId = (_.find(report.container.pages, function (page) {
                    return !(page.meta && page.meta.sourceId);
                }) || report.container.pages[0])._id;
            }
            path += '/pages/' + pageId;
            $location.path(path);
        }
        function init() {
            $scope.options = {
                activeOptions: 'page',
                editable: false
            };
            initDashboard();
            enqueueExport.registerListener($scope);
        }
        $scope.$on('toggleSidebar', function () {
            $scope.navCollapsed = !$scope.navCollapsed;
        });
        angular.extend($scope, {
            /*** PAGE FUNCTIONS ***/
            selectPage: function (page, delay) {
                page.readOnly = true;
                containerEvents.toggleEditing(false);
                rsEnv.set('pageId', page._id);
                $scope.currentPage = page;
                if ($scope.loaded) {
                    metricsService.viewPublicPage(page);
                }
                if (!$scope.orderedPages) {
                    updatePageOrder();
                }
                $timeout(function () {
                    $scope.scrollInfo.jumpToPage = true;
                    $scope.scrollInfo.selectedIndex = $scope.scrollInfo.visibleIndex = $scope.orderedPages.indexOf($scope.currentPage);
                }, delay ? 500 : 0);
            },
            /*** WIDGET FUNCTIONS ***/
            selectWidget: function (widget, evt) {
                if (evt) {
                    evt.stopPropagation();
                }
                if (widget !== $scope.currentWidget) {
                    rsEnv.set('selectedWidgetId', widget && widget._id || null);
                    if ($scope.currentWidget) {
                        broadcastSingleWidget($scope.currentWidget, 'unselected');
                    }
                    if (widget) {
                        $scope.currentWidget = widget;
                        $scope.options.activeOptions = 'widget';
                        broadcastSingleWidget($scope.currentWidget, 'selected');
                    }
                    else {
                        $scope.options.activeOptions = 'page';
                        //wait for the slide to finish
                        $timeout(function () {
                            $scope.currentWidget = null;
                        }, 200);
                    }
                }
            },
            getExport: function (evt, widget) {
                var timezone = timezoneService.getTimezone();
                var url = 'export/surveys/' + rsEnv.get('surveyId');
                url += '/fieldsets/' + rsEnv.get('fieldSetId');
                url += '/containers/' + rsEnv.get('containerId');
                url += '/pages/' + (widget.pageId || rsEnv.get('pageId'));
                url += '/widgets/' + widget._id;
                url += '/export/csv?widgetType=' + widget._type;
                url += '&tz=' + encodeURIComponent(timezone);
                if (!_.isUndefined(widget.childWidgetIndex)) {
                    url += '&childWidgetIndex=' + widget.childWidgetIndex;
                }
                var el = angular.element('<a></a>');
                el[0].href = url;
                el[0].download = widget._id + '.csv';
                angular.element(document.body).append(el);
                el[0].click();
            }
        });
        rootScope.$on('viewresults.downloadResponses', $scope.getExport);
        /*
         * Sets the filters on the environment so they can be picked up by the fieldset service
         */
        function setDashboardFilters(dashboardFilters, opt_updateWidgets) {
            rsEnv.set('pageFilters', dashboardFilters);
            if (opt_updateWidgets) {
                $timeout(function () {
                    broadcastAllWidgets('filtersChanged', dashboardFilters);
                }, 100);
            }
        }
        $scope.$on('reporting.filters.filterChanged', function () {
            setDashboardFilters($scope.dashboard.filters, true);
            // Save the filters on the definition when they change
            containers.saveContainer($scope.dashboard._id, $scope.dashboard);
        });
        // TODO do we need this?
        angular.element($window).bind('resize', function () {
            broadcastAllWidgets('resized');
        });
        function initDashboard() {
            var surveyId = rsEnv.get('surveyId');
            var containerId = rsEnv.get('containerId');
            reportService.getReport(surveyId, containerId)
                .then(function (report) {
                setupEnvironmentAndScope(report);
                metricsService.viewPublicReport(report);
                // find the first page we want to go to
                var page = (_.find($scope.dashboard.pages, {
                    _id: $routeParams.pageId
                }));
                $timeout(function () {
                    if (!page || page && page.meta && page.hidden) {
                        $scope.selectPage($scope.groupedPages.worksheets[0] || $scope.groupedPages.questionPages[0], true);
                    }
                    else if (page) {
                        $scope.selectPage(page, true);
                    }
                    $scope.loaded = true;
                });
            })
                .catch(function (err) {
                $scope.err = err;
            });
        }
        function setupEnvironmentAndScope(report) {
            $scope.dashboard = angular.copy(report.container);
            $scope.dashboard.pages = _.filter(report.container.pages, function (item) {
                return !item.meta || !item.meta.hidden;
            });
            exportService.setupExports($window, $scope.dashboard, $routeParams.pageId);
            $scope.currentFieldset = report.fieldSet;
            rsEnv.set('fieldSetId', report.container.fieldSetId);
            rsEnv.set('snapshotId', report.fieldSet.snapshotId);
            rsEnv.set('dashboardId', report.container._id);
            rsEnv.set('containerId', report.container._id);
            rsEnv.set('containerLastModifiedDate', report.container.lastModifiedDate);
            rsEnv.set('product', report.container.product);
            rsEnv.set('contextMeta', report.container.contextMeta || {});
            rsEnv.set('surveyName', report.fieldSet.name);
            setDashboardFilters($scope.dashboard.filters);
        }
        function broadcastSingleWidget(widget, evt, value) {
            $scope.$broadcast('ripsaw.widgets.' + widget._id + '.' + evt, value);
        }
        function updatePageOrder() {
            $scope.orderedPages = $scope.groupedPages.worksheets.concat($scope.groupedPages.questionPages);
        }
        function broadcastAllWidgets(evt, value) {
            $scope.$broadcast('ripsaw.widgets.' + evt, value);
        }
        $scope.$watchCollection('dashboard.pages', function (value) {
            if (!value) {
                return;
            }
            $scope.groupedPages = _.groupBy($scope.dashboard.pages, function (page) {
                if (page.meta && page.meta.hidden) {
                    return 'hiddenPages';
                }
                else if (page.meta && page.meta.sourceId) {
                    return 'questionPages';
                }
                return 'worksheets';
            });
            $scope.groupedPages.worksheets = $scope.groupedPages.worksheets || [];
            $scope.groupedPages.questionPages = $scope.groupedPages.questionPages || [];
            updatePageOrder();
            if (!$scope.currentPage) {
                // find the first page we want to go to
                var page = ($scope.groupedPages.worksheets[0] || $scope.groupedPages.questionPages[0]);
                if (page) {
                    $scope.selectPage(page);
                }
            }
        });
    }
]);
